module.exports = __webpack_public_path__ + "img/A20b_Robert Norton WWII.f794b691.jpg";